import React from 'react'
import { Nav, NavLink, NavbarContainer, Span, NavLogo, NavItems, GitHubButton, ButtonContainer, MobileIcon, MobileMenu, MobileLink } from './NavbarStyledComponent'
import { FaBars } from 'react-icons/fa';
import { Bio } from '../../data/constants';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import { GitHub } from '@mui/icons-material';
import { useTheme } from 'styled-components';


const Navbar = ({ onProjectsClick }) => {
  const [isOpen, setIsOpen] = React.useState(false);
  const theme = useTheme()
  return (
    <Nav>
      <NavbarContainer>
        <NavLogo to='/'>
          <a href="#about" style={{ display: "flex", alignItems: "center", color: "white", marginBottom: '20;', cursor: 'pointer', textDecoration: 'none' }}>
            <img src="/sitelogo.png" alt="Hammad Ahmed Logo" style={{ width: "3rem", height: "3rem", marginRight: "8px" }} /> <Span>Hammad Ahmed</Span>
          </a>
        </NavLogo>
        <MobileIcon>
          <FaBars onClick={() => {
            setIsOpen(!isOpen)
          }} />
        </MobileIcon>
        <NavItems>
          <NavLink href="#about">About</NavLink>
          <NavLink href='#skills'>Skills</NavLink>
          <NavLink href='#experience'>Experience</NavLink>
          <NavLink href="#" onClick={(e) => { e.preventDefault(); onProjectsClick(); }}>Projects</NavLink>
          <NavLink href='#education'>Education</NavLink>
        </NavItems>
        <ButtonContainer>
          <GitHubButton href={Bio.linkedin} target="_blank">
            <LinkedInIcon style={{ marginRight: '8px' }} /> {/* LinkedIn Icon */}
            LinkedIn
          </GitHubButton>
          <GitHubButton href={Bio.github} target="_blank">
            <GitHub style={{ marginRight: '8px' }} /> {/* GitHub Icon */}
            Github
          </GitHubButton>
        </ButtonContainer>
        {
          isOpen &&
          <MobileMenu isOpen={isOpen}>
            <MobileLink href="#about" onClick={() => {
              setIsOpen(!isOpen)
            }}>About</MobileLink>
            <MobileLink href='#skills' onClick={() => {
              setIsOpen(!isOpen)
            }}>Skills</MobileLink>
            <MobileLink href='#experience' onClick={() => {
              setIsOpen(!isOpen)
            }}>Experience</MobileLink>
            <MobileLink href="#" onClick={(e) => {
              e.preventDefault();
              setIsOpen(!isOpen);
              onProjectsClick();
            }}>Projects</MobileLink>
            <MobileLink href='#education' onClick={() => {
              setIsOpen(!isOpen)
            }}>Education</MobileLink>
            <GitHubButton style={{ padding: '10px 16px', background: `${theme.primary}`, color: 'white', width: 'max-content' }} href={Bio.linkedin} target="_blank">
              <LinkedInIcon style={{ marginRight: '8px' }} /> {/* LinkedIn Icon */}
              LinkedIn
            </GitHubButton>
            <GitHubButton style={{ padding: '10px 16px', background: `${theme.primary}`, color: 'white', width: 'max-content' }} href={Bio.github} target="_blank">
              <GitHub style={{ marginRight: '8px' }} /> {/* GitHub Icon */}
              Github
            </GitHubButton>
          </MobileMenu>
        }
      </NavbarContainer>
    </Nav >
  )
}

export default Navbar